import {deviceConnectionStatusTypes} from 'iqos-mw';
import {createSelector} from 'reselect';

import {getDeviceNameByType} from '@/services/device/deviceData';

const selectMw = (state) => state.mw;

const selectDeviceName = createSelector(selectMw, (mw) => mw.deviceName);

const selectMwChargerData = createSelector(selectMw, (mw) => mw.charger);

const selectMwHolderData = createSelector(selectMw, (mw) => mw.holder);

const selectConnectionError = createSelector(selectMw, (mw) => mw.connectionError);

const selectMwDeviceType = createSelector(selectMwChargerData, (charger) => charger?.type);

const selectChargerCodentify = createSelector(selectMwChargerData, (charger) => charger?.codentify);

const selectHolderCodentify = createSelector(selectMwHolderData, (holder) => holder?.codentify);

const selectIsDeviceInitialized = createSelector(selectChargerCodentify, (chargerCodentify) => !!chargerCodentify);

const selectIsHolderInitialized = createSelector(selectHolderCodentify, (holderCodentify) => !!holderCodentify);

const selectChargerConnectionStatus = createSelector(selectMwChargerData, (charger) => charger?.connectionStatus);
const selectIsDeviceConnected = createSelector(selectChargerConnectionStatus, (chargerConnectionStatus) =>
    deviceConnectionStatusTypes.isConnected(chargerConnectionStatus)
);
const selectIsDeviceDisconnected = createSelector(selectChargerConnectionStatus, (chargerConnectionStatus) =>
    deviceConnectionStatusTypes.isDisconnected(chargerConnectionStatus)
);

const selectHolderConnectionStatus = createSelector(selectMwHolderData, (holder) => holder?.connectionStatus);
const selectIsHolderConnected = createSelector(selectHolderConnectionStatus, (holderConnectionStatus) =>
    deviceConnectionStatusTypes.isConnected(holderConnectionStatus)
);

const selectDeviceDefaultName = createSelector(selectMwDeviceType, (deviceType) => getDeviceNameByType(deviceType));

export {
    selectChargerCodentify,
    selectConnectionError,
    selectDeviceDefaultName,
    selectDeviceName,
    selectHolderCodentify,
    selectIsDeviceConnected,
    selectIsDeviceDisconnected,
    selectIsDeviceInitialized,
    selectIsHolderConnected,
    selectIsHolderInitialized,
    selectMwChargerData,
    selectMwDeviceType,
    selectMwHolderData,
};
